import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";
import { appContext } from "../../../AppContext";
import { JSX } from "react";
import LegacyApiClient from "../../../Providers.Api/LegacyApiClient";
import { Button, ButtonBar, Card, CopyButton, Dialog, DialogContent, DialogFooter, GridContainer, GridItem, List, ListItem, RightButtons, Typography } from "@iconics/components";

export class DiagnosticsDialog extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            IBSS_API: "",
            IBSS_Data_API: "",
        }
    }

    public componentDidUpdate(prevProps: IProps): void
    {
        if (prevProps.open !== this.props.open && this.props.open)
        {
            this.handleOpen();
        }
    }

    private async handleOpen(): Promise<void>
    {
        const { apiClient } = appContext();
        try
        {
            const version = await LegacyApiClient.getPlatformApiVersion();
            this.setState({ IBSS_API: version });
        }
        catch
        {
            this.setState({ IBSS_API: "" });
        }

        try
        {
            const version = await LegacyApiClient.getDataApiVersion();
            this.setState({ IBSS_Data_API: version });
        }
        catch
        {
            this.setState({ IBSS_Data_API: "" });
        }
    }

    private handleCopyClick(): string
    {
        const { labels } = appContext();
        const { settings } = appContext();

        const lines: string[] = [];
        lines.push(`- ${labels.Platform_Diagnostics_ReleaseVersion} ${settings.externalVersion || labels.funcUnknown_S}`);
        lines.push(`  - MONZA Platform Portal: ${settings.internalVersion || labels.funcUnknown_S}`);
        lines.push(`  - MONZA Platform API: ${this.state.IBSS_API || labels.funcUnknown_S}`);
        lines.push(`  - MONZA Data API: ${this.state.IBSS_Data_API || labels.funcUnknown_S}`);
        return lines.join('\n');
    }

    public render(): JSX.Element
    {
        const { labels } = appContext();
        const { settings } = appContext();

        return (
            <Dialog
                isOpen={this.props.open}
                onOpenChange={() => this.props.onClose()}
                width={4}
            >
                <DialogContent>
                    <Card
                        title={labels.Platform_Diagnostics_Title}
                        actions={<CopyButton onClick={() => this.handleCopyClick()} />}
                    >
                        <GridContainer
                            spacing="xs"
                        >
                            <GridItem>
                                <Typography role="body" size="medium">
                                    {labels.Platform_Diagnostics_ReleaseVersion} {settings.externalVersion || labels.funcUnknown_S}
                                </Typography>
                            </GridItem>
                            <GridItem>
                                <ul
                                    style={{
                                        listStyleType: 'disc',
                                        paddingLeft: 'var(--spacing-sd-system-dimension-spacing-extra-large)'
                                    }}
                                >
                                    <li><Typography role="body" size="medium" inline>MONZA Platform Portal: {settings.internalVersion || labels.funcUnknown_S}</Typography></li>
                                    <li><Typography role="body" size="medium" inline>MONZA Platform API: {this.state.IBSS_API || labels.funcUnknown_S}</Typography></li>
                                    <li><Typography role="body" size="medium" inline>MONZA Data API: {this.state.IBSS_Data_API || labels.funcUnknown_S}</Typography></li>
                                </ul>
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                onClick={() => this.props.onClose()}
                            >
                                {labels.Platform_CommonAction_Ok}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>
            </Dialog>
        );
    }
}

export interface IProps
{
    open: boolean;
    onClose: () => void;
}

export interface IState
{
    IBSS_API: string;
    IBSS_Data_API: string;
}
